var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedCatalogue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Catalogue, Property 2=ON"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009332"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5006 4.80151H17.2507C17.7149 4.80151 18.1601 4.99114 18.4883 5.32868C18.8165 5.66621 19.0009 6.12401 19.0009 6.60136V19.2003C19.0009 19.6776 18.8165 20.1354 18.4883 20.473C18.1601 20.8105 17.7149 21.0001 17.2507 21.0001H6.75011C6.28595 21.0001 5.8408 20.8105 5.51259 20.473C5.18439 20.1354 5 19.6776 5 19.2003V6.60136C5 6.12401 5.18439 5.66621 5.51259 5.32868C5.8408 4.99114 6.28595 4.80151 6.75011 4.80151H8.50021",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.6253 2.99988H9.37493C8.89165 2.99988 8.49988 3.40279 8.49988 3.8998V5.69965C8.49988 6.19666 8.89165 6.59957 9.37493 6.59957H14.6253C15.1085 6.59957 15.5003 6.19666 15.5003 5.69965V3.8998C15.5003 3.40279 15.1085 2.99988 14.6253 2.99988Z",
    fill: "white",
    stroke: "#68A14B",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedCatalogue);
export default __webpack_public_path__ + "static/media/selected-catalogue.51adaa0b0c0c3e2ebede56535383571d.svg";
export { ForwardRef as ReactComponent };